import React from 'react';
import type { FunnelInsightNodeMetric } from '../types';

interface FunnelNodeMetricBadgeProps {
  metric: FunnelInsightNodeMetric;
}

export const FunnelNodeMetricBadge: React.FC<FunnelNodeMetricBadgeProps> = ({ metric }) => {
  const conversionHint = metric.visitors > 0
    ? Math.round(((metric.visitors - metric.exits) / metric.visitors) * 100)
    : 0;

  return (
    <div
      data-testid={`funnel-insights-node-${metric.screenId}`}
      title={`${metric.visitors} visitors, ${metric.exits} exits`}
      style={{
        position: 'absolute',
        top: -10,
        right: -10,
        minWidth: 78,
        padding: '5px 7px',
        borderRadius: 6,
        background: 'rgba(17, 24, 39, 0.92)',
        border: '1px solid rgba(255, 255, 255, 0.18)',
        color: '#fff',
        boxShadow: '0 6px 18px rgba(15, 23, 42, 0.24)',
        fontSize: 11,
        lineHeight: 1.2,
        zIndex: 6,
        pointerEvents: 'none',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
        <strong style={{ fontSize: 12 }}>{metric.visitors}</strong>
        <span style={{ color: 'rgba(255,255,255,0.68)' }}>{conversionHint}%</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 2 }}>
        <span>Exit</span>
        <span>{metric.exits}</span>
      </div>
      {metric.isPaywallScreen && (
        <div style={{ marginTop: 2, color: '#fde68a', whiteSpace: 'nowrap' }}>
          {metric.paywallType || 'paywall'}
        </div>
      )}
    </div>
  );
};
